import { useEffect, useState } from "react";
import { dropAmong } from "@omnabase/shared";

/** A dragged order shown at once (one management screen, 2026-10-12): the rows take their new places on the drop, while the save runs; the
 *  server's next answer replaces it (also when the save failed: the old order comes back). */
export function useDroppedOrder(serverIds: string[]): { ids: string[]; drop: (visible: string[], from: number, to: number, save: (order: string[]) => Promise<unknown>) => Promise<void> } {
  const [shown, setShown] = useState<string[] | null>(null);
  const key = serverIds.join(",");
  useEffect(() => { setShown(null); }, [key]);
  const ids = shown ?? serverIds;
  const drop = async (visible: string[], from: number, to: number, save: (order: string[]) => Promise<unknown>) => {
    const order = dropAmong(ids, visible, visible[from]!, to);
    if (!order) return;
    setShown(order);
    try { await save(order); } catch (e) { setShown(null); throw e; }
  };
  return { ids, drop };
}
